<script setup lang="ts">
// Renders cluster terms content exactly as end users see it. The admin preview and the
// user-facing acceptance gate must both consume this component so they never drift.
defineProps<{ content: string }>();
</script>

<template>
  <KUICoreInputRichTextEditorRenderer
    :content="content"
    variant="paragraph"
    class="text-foreground"
    data-testid="terms-document"
  />
</template>
